import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { branch, compose, lifecycle } from 'recompose'
import { withGlobalRoles } from 'containers/Role/utils'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import * as R from 'ramda'

import {
  postLogoutUser,
} from 'containers/User/Login/actions'

import {
  nameSelector,
} from 'containers/User/Login/selectors'

import {
  fetchApprovalCount
} from 'containers/Approval/ApprovalPage/actions'

import Appbar from './Appbar'

const mapStateToProps = (state) => {
  return {
    count: state.approvals.approvalCount,
    name: nameSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(postLogoutUser()),
    fetchApprovalCount: () => dispatch(fetchApprovalCount()),
  }
}

const AppbarContainer = (props) => <Appbar {...props}/>

const notClientRole = compose(
  R.not,
  R.contains(GLOBAL_ROLES.CLIENT_ACCESS),
  R.prop('ownRoles')
)

const withApprovalCount = lifecycle({
  componentWillMount() {
    this.props.fetchApprovalCount()
  },
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location)
      this.props.fetchApprovalCount()
  }
})

const withApprovalCountListener = compose(
  withGlobalRoles,
  branch(
    notClientRole,
    withApprovalCount
  )
)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withRouter,
  withConnect,
  withApprovalCountListener
)

export default enhance(AppbarContainer)
